import React, { useState, useEffect } from 'react';
import ResponsiveContainer from './layout/ResponsiveContainer';
import SharedHeaderHomeowner from './SharedHeaderHomeowner';

interface ServicedZipsProps {
  onNavigate: (screen: string) => void;
}

const ServicedZips: React.FC<ServicedZipsProps> = ({ onNavigate }) => {
  const [allowedZips, setAllowedZips] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Load the allowed ZIPs from the generated JSON file
    const loadAllowedZips = async () => {
      try {
        const response = await fetch('/src/data/allowedZips.json');
        if (response.ok) {
          const zips = await response.json();
          setAllowedZips(zips);
        } else {
          console.error('Failed to load allowed ZIPs');
        }
      } catch (error) {
        console.error('Error loading allowed ZIPs:', error);
      } finally {
        setLoading(false);
      }
    };

    loadAllowedZips();
  }, []);

  return (
    <ResponsiveContainer>
      <SharedHeaderHomeowner onNavigate={onNavigate} />
      
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="max-w-4xl mx-auto px-4">
          <div className="bg-white rounded-lg shadow-lg p-8">
            <div className="text-center mb-8">
              <h1 className="text-3xl font-bold text-gray-900 mb-4">
                Serviced ZIP Codes
              </h1>
              <p className="text-lg text-gray-600">
                These are the ZIP codes where CoreBids currently provides roofing services.
              </p>
            </div>

            {loading ? (
              <div className="text-center py-8">
                <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                <p className="mt-2 text-gray-600">Loading ZIP codes...</p>
              </div>
            ) : (
              <div>
                <div className="mb-6">
                  <p className="text-sm text-gray-500 mb-2">
                    Total serviced ZIP codes: <span className="font-semibold">{allowedZips.length}</span>
                  </p>
                </div>
                
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2">
                  {allowedZips.map((zip, index) => (
                    <div
                      key={index}
                      className="bg-blue-50 border border-blue-200 rounded-lg p-3 text-center hover:bg-blue-100 transition-colors"
                    >
                      <span className="font-mono text-blue-800 font-semibold">{zip}</span>
                    </div>
                  ))}
                </div>

                <div className="mt-8 text-center">
                  <p className="text-gray-600 mb-4">
                    Don't see your ZIP code? We're expanding rapidly!
                  </p>
                  <button
                    onClick={() => onNavigate('waitlist')}
                    className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors"
                  >
                    Join Waitlist
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </ResponsiveContainer>
  );
};

export default ServicedZips;
